var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xs-12 text--base chart__white"},[(_vm.heatmapTitle)?_c('HeatmapInsurance',{attrs:{"content":_vm.heatmapTitle}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }